// import {styled} from '@mui/material/styles';

// import SilverContext from '../../context/silver'
// <SilverContext></SilverContext>

// import TreasuryContext, {useTreasury} from '../../context/treasury'

import Foot from '../Foot'
import AppBar from '../AppBar'
// import Protocol from '../Protocol'
// import { withRouter } from 'react-router-dom';

function ContentPage() {
    return <Foot />
}

function Home() {
    return (
        <>
                <AppBar />
                <ContentPage />
                {/* <Register /> */}
                {/* <Foot /> */}
                {/* 
                <Foot /> */}
                {/* <Protocol /> */}
        </>

    )
}

// export default withRouter(Home)
export default Home

// const FootWraper = styled('div')`
//     width: 100%;
//     position: relative;
//     height: ${p => p.h || '34px'};
// `